import api from './client';

export const fetchUniUniShipments = (params: any) =>
  api.get('/uniuni/shipments', { params }).then(res => res.data);

export const printUniUniLabel = (packageId: string) =>
  api.post('/uniuni/printlabel', { packageId, labelType: 6, labelFormat: 'pdf', type: 'pdf' }, { responseType: 'blob' })
    .then(res => res);

export const printUniUniLabelsBulk = (shipments: { packageId: string; orderId?: number | string }[]) =>
  api.post('/uniuni/printlabels/bulk', { shipments }, { responseType: 'blob' })
    .then(res => res);

export const downloadPackingSlip = (orderId: number) =>
  api.post('/uniuni/packingslip', { orderId }, { responseType: 'blob' })
    .then(res => res);

export const fetchUniUniTracking = (trackingNumber: string) =>
  api.get(`/uniuni/tracking/${encodeURIComponent(trackingNumber)}`).then(res => res.data);

export interface VoidShipmentResult {
  orderId: number | string;
  uniuniCancel: { attempted: boolean; ok: boolean; trackingNumber: string | null; error?: string };
  inventoryRestore: {
    attempted: number;
    restored: number;
    failed: number;
    errors: Array<{ sku: string; qty: number; body: unknown }>;
  };
  localReverted: boolean;
}

export const voidShipment = (orderId: number | string, reason?: string) =>
  api
    .post<VoidShipmentResult>(`/uniuni/shipments/${encodeURIComponent(String(orderId))}/void`, {
      reason,
    }, { timeout: 120_000 })
    .then((r) => r.data);
